import { Modelo } from '@ext/index';
import * as Types from './Respuesta.types';
import moment, { Moment } from 'moment';
import { isArray } from 'util';

export class IRespuesta extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Curso: number = 0;
    public Pregunta: number = 0;
    public Usuario: number = 0;
    public Posicion: number = 0;
    public Correcta: boolean = false;
    public Respondida: boolean = false;
    public Observacion: string = '';
    public Fecha: Moment = moment( '' );

    public OpcionesElegidas: OpcionElegida[] = [];

    public set(): boolean
    {

        this.Curso = !this.Json.curso ? 0 : this.Json.curso;
        this.Pregunta = !this.Json.pregunta ? 0 : this.Json.pregunta;
        this.Usuario = !this.Json.usuario ? 0 : this.Json.usuario;
        this.Observacion = !this.Json.observacion ? '' : this.Json.observacion;
        this.Correcta = this.Json.correcta == 'S';
        this.Respondida = this.Json.respondida == 'S';
        this.Fecha = !this.Json.fecha ? moment( '' ) : moment( this.Json.fecha );

        if ( isArray( this.Json.respuestas ) )
        {
            for ( let e of this.Json.respuestas )
            {
                this.OpcionesElegidas.add( new OpcionElegida( e ) );
            }
        }

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IRespuesta )
    {
        this.Model = Model;
    }

    public Model: IRespuesta;
}

export class OpcionElegida extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Curso: number = 0;
    public Pregunta: number = 0;
    public Usuario: number = 0;
    public Opcion: number = 0;
    public Correcta: boolean = false;
    public Fecha: Moment = moment( '' );

    public set(): boolean
    {
        this.Curso = !this.Json.curso ? 0 : this.Json.curso;
        this.Pregunta = !this.Json.pregunta ? 0 : this.Json.pregunta;
        this.Usuario = !this.Json.usuario ? 0 : this.Json.usuario;
        this.Opcion = !this.Json.opcion ? 0 : this.Json.opcion;
        this.Correcta = this.Json.correcta == 'S';
        this.Fecha = !this.Json.fecha ? moment( '' ) : moment( this.Json.fecha );

        this.Existe = true;
        return this.Existe;
    }

}